import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import { WORK_HONESTLY_MESSAGES } from '../../constants';

import * as styles from './ApprovalNew.css';

export enum EApprovalType {
  HasVerifiedDocuments = 'hasVerifiedDocuments',
}

export interface IApprovalNewProps {
  type: EApprovalType;
}

export const ApprovalNew = ({ type }: IApprovalNewProps) => {
  switch (type) {
    case EApprovalType.HasVerifiedDocuments:
      return (
        <div className={styles['container']} data-testid="approval-has-verified-documents">
          <div className={`${styles['icon']} ${styles['has-verified-documents']}`} />
          <UIText1>{WORK_HONESTLY_MESSAGES.agent}</UIText1>
        </div>
      );

    default:
      return null;
  }
};
